module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/menu_scroll-40050f9294d1bc640c6804623de1a4a9.png";